import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { AsyncStatus } from 'lib-shared-legacy-types';
import { Component } from 'react';
import { Field } from 'redux-form';

type PropsT = {
  fieldLabel: string;
  availableOptions: Array<any>;
  singleChoice: boolean | null;
  required: boolean | null;
  status: AsyncStatus;
  className: string | null;
  removable: boolean;
  elementItem: any;
  getfunction: () => Promise<any>;
  touchOnChange: (isTouched: boolean) => void;
  touch: (form: string, field: string) => void;
  stopFormSubmit: ((form: string, errors: any) => void) | null;
  placeholder: string | null;
  error: string | null;
  index: number;
} & any;

type StateT = {
  isOpen: boolean;
  nameValue: string;
};

class UserEmailOption extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);
    this.state = {
      isOpen: false,
      nameValue: '',
    };
  }

  componentDidMount() {
    const field = this.props.fields.get(this.props.index);
    let nameValue = '';

    if (
      (field.user.name && typeof field.user.name === 'string') ||
      (field.user.display_name && typeof field.user.display_name === 'string')
    ) {
      nameValue = field.user.display_name
        ? field.user.display_name
        : field.user.name
          ? field.user.name
          : '';
    }
    this.setState({ nameValue: nameValue });
  }

  componentDidUpdate() {
    const field = this.props.fields.get(this.props.index);

    let nameValue = '';
    if (this.state.nameValue === '') {
      if (
        (field.user.name && typeof field.user.name === 'string') ||
        (field.user.display_name && typeof field.user.display_name === 'string')
      ) {
        nameValue = field.user.display_name
          ? field.user.display_name
          : field.user.name
            ? field.user.name
            : '';
      }

      if (nameValue !== '') {
        this.setState({ nameValue: nameValue });
      }
    }
  }

  onClickCloseAddName = () => {
    this.setState({ isOpen: false, nameValue: '' });
  };

  onChangeName = (e) => {
    this.setState({ nameValue: e.target.value });
  };

  onBlurAddNameBtn = () => {
    if (this.state.nameValue && this.state.nameValue.trim() !== '') {
      this.props.change(
        `${this.props.fields.name}[${this.props.index}].user.display_name`,
        this.state.nameValue,
      );
      this.setState({ isOpen: false });
    }
  };

  onClickAddNameInput = () => {
    if (this.state.nameValue && this.state.nameValue.trim() !== '') {
      this.props.change(
        `${this.props.fields.name}[${this.props.index}].user.display_name`,
        this.state.nameValue,
      );
      this.setState({ isOpen: false, nameValue: '' });
    } else {
      this.setState({ isOpen: false });
    }
  };

  onClickEditName = () => {
    this.setState({ isOpen: true });
  };

  render() {
    const { fields, index, contactField, fieldLabel, removable } = this.props;
    const field = contactField ? { user: contactField } : fields.get(index);

    let name = null;
    let fieldLabelHtml: JSX.Element | null = null;
    let nameKey = 'name';

    if (
      (field.user.name && typeof field.user.name === 'string') ||
      (field.user.display_name && typeof field.user.display_name === 'string')
    ) {
      name = field.user.display_name
        ? field.user.display_name
        : field.user.name
          ? field.user.name
          : null;
    }

    if (field.user.id && field.user.display_name) {
      nameKey = 'display_name';
    }

    if (fieldLabel) {
      fieldLabelHtml = (
        <label>{fieldLabel + (removable === false ? ' *' : '')}</label>
      );
    }

    const displayname =
      name !== null ? `${name} <${field.user.email}>` : field.user.email;

    return (
      <div className="selected-email field-action">
        <div className="selected-email-label">
          <Tooltip content={displayname}>
            <span className="label-email">
              {fieldLabelHtml}
              {displayname}
              <button
                type="button"
                className="edit-btn-user-name hidden"
                onClick={this.onClickEditName}
              >
                <Icon name="pen" />
              </button>
            </span>
          </Tooltip>
          <div
            className={`add-name ${this.state.isOpen === true ? '' : 'hidden'}`}
          >
            <button
              type="button"
              className="btn remove-btn remove-name-btn"
              onClick={this.onClickCloseAddName}
            >
              <Icon name="close" />
            </button>
            <div className="add-name-header">
              <Icon name="user-plus" className="header-plus-icon" />
              <span className="add-name-header-text">
                Add name to {field.user.email}
              </span>
            </div>
            <Field
              className="add-name-input"
              type="text"
              onChange={this.onChangeName}
              onBlur={this.onBlurAddNameBtn}
              name={`${contactField}.user.${nameKey}`}
              component="input"
              placeholder=""
            />
            <button
              type="button"
              className="btn btn-add-name btn-primary outlined"
              onClick={this.onClickAddNameInput}
            >
              Add
            </button>
          </div>
          <Tooltip
            content={
              removable === true
                ? `Remove ${field.user.email}`
                : `${field.user.email} is the requester and can not be removed.`
            }
          >
            <button
              type="button"
              className={
                'btn remove-user-btn ' + (removable === true ? '' : 'disable')
              }
              onClick={
                removable === true
                  ? () => {
                      fields.remove(index);
                    }
                  : () => {
                      /** Noop. */
                    }
              }
            >
              <Icon name="close" />
            </button>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default UserEmailOption;
